<template>
    <div>
        <div class="ah-panel setup-staff-page">
            <div class="panel-header gray init-step-header">
                <h1 class="title">建立員工</h1>
                <div class="description">
                    <p>建立您公司的員工帳號，並給予“開請款單”、“申請發票”、等權限。建立後，該員工將會收到系統啟用信。</p>
                    <div class="account-amt" style="margin-top: 15px">可用帳號 {{ accountMaxNum }} 個 / 已啟用帳號 {{ accountUsedNum }} 個</div>
                </div>
            </div>
            <div class="panel-body">
                <el-table :data="staffList" empty-text="沒有員工" v-loading="isLoadingStaffs">
                    <el-table-column type="index" label="#"></el-table-column>
                    <el-table-column prop="nam" label="姓名"></el-table-column>
                    <el-table-column prop="eml" label="帳號 (E-mail）"></el-table-column>
                    <el-table-column prop="deP_NAM" label="部門"></el-table-column>
                    <el-table-column prop="adm" label="管理員權限">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.adm === 1" size="small" type="success">管理員</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="操作" width="80">
                        <template slot-scope="scope">
                            <el-button size="mini" @click="handleEdit(scope.row)">編輯</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: center; margin-top: 30px; margin-bottom: 30px;">
                    <el-button plain type="primary" class="primary-action" @click="handleAddBtnClick" v-if="accountUsedNum < accountMaxNum" round>新增員工</el-button>
                    <el-alert type="warning" center v-if="accountUsedNum >= accountMaxNum" :closable="false">員工人數已達您購買方案的上限。如需增加請聯絡客服人員。</el-alert>
                </div>
                <center class="actions">
                    <el-button type="" class="primary-action" @click="handlePrev">回上一步</el-button>
                    <el-button type="primary" class="primary-action" @click="handleNext">下一步</el-button>
                </center>
            </div>
        </div>
        <el-dialog :visible.sync="editDialogVisible" width="" :before-close="handleEditDialogClose" :close-on-click-modal="false" class="ah-detail-dialog">
            <template slot="title">
                新增員工
            </template>
            <div class="detail-row">
                <div class="detail-block">
                    <el-form ref="form" :rules="rules" :model="form" label-width="200px">
                        <el-divider content-position="left">員工資訊</el-divider>
                        <div style="max-width: 750px; margin: 0 auto 60px auto;">
                            <el-form-item prop="eml" label="帳號 (E-mail)" required>
                                <el-input v-model="form.eml"></el-input>
                            </el-form-item>
                            <el-form-item prop="nam" label="姓名">
                                <el-input v-model="form.nam"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <template slot="label">專案代碼<ah-tip>兩個英文或數字，會出現在該帳號建立的專案編號上。</ah-tip></template>
                                <el-input v-model="form.pJ_NO" maxlength="2" style="max-width: 200px"></el-input>
                            </el-form-item>
                            <el-form-item label="所屬部門">
                                <ah-el-select-dep v-model="form.deP_SNO"></ah-el-select-dep>
                                <ah-tip>直接輸入可新增。</ah-tip>
                            </el-form-item>
                            <el-form-item>
                                <template slot="label"> 直屬主管<ah-tip>請款、開發票的主管審核人。</ah-tip> </template>
                                <ah-el-select-staff v-model="form.boS_SNO"></ah-el-select-staff>
                            </el-form-item>
                            <el-form-item label="系統管理者權限">
                                <el-radio v-model="form.adm" :label="1">是</el-radio>
                                <el-radio v-model="form.adm" :label="0">否</el-radio>
                                <el-alert
                                    type="success"
                                    :closable="false"
                                    title="系統管理者"
                                    description="可使用“設定”相關功能。例如：公司資訊、員工、收支項目、審核流程..."
                                    style="line-height: 100%;padding-top: 12px; padding-bottom: 12px;"
                                ></el-alert>
                            </el-form-item>
                            <el-form-item prop="grP_NO" label="">
                                <template slot="label"> 身份<ah-tip>用於下方權限預設（可自訂）</ah-tip> </template>
                                <el-select v-model="form.grP_NO" placeholder="請選擇" no-data-text="無資料" @change="fetchInitMenu">
                                    <el-option v-for="item in roleList" :key="item.grP_NO" :label="item.grP_NAM" :value="item.grP_NO"> </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item v-if="form.grP_NO == 'PRO'" prop="pJ_NO" label="專案代號">
                                <el-input v-model="form.pJ_NO" maxlength="2" show-word-limit></el-input>
                            </el-form-item>
                        </div>
                        <el-divider content-position="left">薪轉帳戶</el-divider>
                        <div style="max-width: 750px; margin: 0 auto 60px auto;">
                            <el-form-item prop="stafF_BNK_BOO" label="銀行">
                                <ah-el-select-bank v-model="form.stafF_BNK_BOO" :branch="form.stafF_BNK_DOO" @branchInput="form.stafF_BNK_DOO = $event" :disabled="false"></ah-el-select-bank>
                            </el-form-item>
                            <el-form-item prop="stafF_BNK_ACC" label="帳號" style="max-width: 800px;">
                                <ah-el-input-bank-acc v-model="form.stafF_BNK_ACC" :bankBoo="form.stafF_BNK_BOO"></ah-el-input-bank-acc>
                            </el-form-item>
                            <el-form-item prop="stafF_BNK_TPC" label="戶名">
                                <el-input v-model="form.stafF_BNK_TPC" style="max-width: 300px;"></el-input>
                            </el-form-item>
                        </div>
                        <el-divider content-position="left">詳細權限</el-divider>
                        <div style="max-width: 750px; margin: 0 auto 60px auto;">
                            <div class="setup-authority-table">
                                <div v-for="(item, index) in menuList" :key="index" class="authority-group">
                                    <div class="root-item">
                                        <el-checkbox
                                            :indeterminate="checkSomeStatus(item.title.unt)"
                                            :value="checkStatus(item.title.unt)"
                                            @change="event => handleCheckAllChange(event, item.title.unt)"
                                            >{{ item.title.unT_NAM }}</el-checkbox
                                        >
                                    </div>
                                    <el-checkbox-group v-model="form.untList" class="group-items">
                                        <span v-for="subItem in item.subMenus" :key="subItem.unt" class="sub-item">
                                            <el-checkbox :label="subItem.unt" class="item">{{ subItem.unT_NAM }}</el-checkbox>
                                        </span>
                                    </el-checkbox-group>
                                </div>
                            </div>
                        </div>
                    </el-form>
                </div>
            </div>
            <div class="detail-row footer" style="text-align: center;">
                <el-button type="primary" class="primary-action" :loading="isAddingStaff" @click="submitAdd">送出</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import ahElSelectDep from '@/components/ui/ahElSelectDep';
import ahElSelectStaff from '@/components/ui/ahElSelectStaff';
import ahElSelectBank from '@/components/ui/ahElSelectBank';
import ahElInputBankAcc from '@/components/ui/ahElInputBankAcc';
import ahTip from '@/components/ui/ahTip';

export default {
    components: {
        ahElSelectDep,
        ahElSelectStaff,
        ahElSelectBank,
        ahElInputBankAcc,
        ahTip,
    },
    data() {
        const checkEmail = (rule, value, callback) => {
            const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
            if (!value) {
                return callback(new Error('請填寫帳號'));
            }
            setTimeout(() => {
                if (mailReg.test(value)) {
                    callback();
                } else {
                    callback(new Error('請輸入正確的 E-mail 格式'));
                }
            }, 100);
        };

        return {
            accountMaxNum: 0,
            totalDataCount: 0,
            form: {},
            rules: {
                nam: [
                    {
                        required: true,
                        trigger: 'blur',
                        message: '請填寫姓名',
                    },
                ],
                eml: [
                    {
                        validator: checkEmail,
                        trigger: 'blur',
                    },
                ],
                grP_NO: [
                    {
                        required: true,
                        trigger: 'change',
                        message: '請選擇身份',
                    },
                ],
                pJ_NO: [
                    {
                        required: true,
                        message: '專案經理必須輸入專案代號',
                        trigger: 'change',
                    },
                ],
            },
            staffList: [],
            roleList: [],
            departmentList: [],
            departmentListFilterd: [],
            menuList: [],
            editDialogVisible: false,
            isLoadingStaffs: false,
            isAddingStaff: false,
            quickAdd: {
                depNam: '',
            },
        };
    },
    mounted() {
        this.resetForm();
        this.updateStaffList();
        this.fetchRoleList();
        this.fetchAuthorityMenus();
    },
    methods: {
        // 重設新增員工表單
        resetForm() {
            this.form = {
                adm: 1,
                sno: null,
                onf: 1, // 啟用
                pJ_NO: '',
                untList: [],
                stafF_BNK_BOO: '',
                stafF_BNK_DOO: '',
                stafF_BNK_ACC: '',
                stafF_BNK_TPC: '',
            };
        },
        // 取得員工列表
        updateStaffList() {
            this.isLoadingStaffs = true;
            this.$api({
                url: '/StaffManagementPage/GetStaffList?PageSize=999&PageNum=1',
                method: 'GET',
            })
                .then((resp) => {
                    this.staffList = resp.data.staffs.reverse();
                    this.accountMaxNum = resp.data.cnt;
                    this.accountUsedNum = resp.data.rnt;
                })
                .finally(() => {
                    this.isLoadingStaffs = false;
                });
        },

        // 取得身分下拉選單
        fetchRoleList() {
            this.$api({
                url: '/StaffManagementPage/GetRoleOptions',
                method: 'GET',
            }).then((resp) => {
                this.roleList = resp.data.options;
            });
        },

        // 取得權限MENU
        fetchAuthorityMenus() {
            this.$api({
                url: '/StaffManagementPage/GetAuthorityMenus',
                method: 'GET',
            }).then((resp) => {
                this.menuList = resp.data.menus;
            });
        },

        // 取得人員明細
        fetchStaffData(sno) {
            this.$api({
                url: `/StaffManagementPage/GetStaff?sno=${sno}`,
                method: 'GET',
            }).then((resp) => {
                this.form = resp.data.staff;
                console.log(resp.data.staff);
            });
        },

        // 取得身份對應的權限欄位
        fetchInitMenu(value) {
            this.$api({
                url: `/StaffManagementPage/GetDefaultUntList?GRP_NO=${value}`,
                method: 'GET',
            }).then((resp) => {
                this.form.untList = resp.data.untList;
            });
        },

        // 編輯按鈕
        handleEdit(data) {
            this.fetchStaffData(data.sno);
            this.editDialogVisible = true;
        },

        // 增加員工按鈕
        handleAddBtnClick() {
            this.resetForm();
            this.editDialogVisible = true;
        },

        // 編輯視窗關閉事件
        handleEditDialogClose() {
            this.editDialogVisible = false;
            this.updateStaffList();
        },

        // 權限設定
        checkSomeStatus(type) {
            const thisMenuIds = this.menuList.find((x) => x.title.unt === type).subMenus.map((y) => y.unt);

            return thisMenuIds.some((v) => this.form.untList.includes(v)) && !thisMenuIds.every((v) => this.form.untList.includes(v));
        },

        // 權限設定
        checkStatus(type) {
            const thisMenuIds = this.menuList.find((x) => x.title.unt === type).subMenus.map((y) => y.unt);

            return thisMenuIds.every((v) => this.form.untList.includes(v));
        },

        // 權限設定
        handleCheckAllChange(event, type) {
            const thisMenuIds = this.menuList.find((x) => x.title.unt === type).subMenus.map((y) => y.unt);

            if (event) {
                thisMenuIds.forEach((item) => {
                    this.form.untList.push(item);
                });
            } else {
                this.form.untList = this.form.untList.filter((x) => !thisMenuIds.includes(x));
            }
        },

        // 儲存
        submitAdd() {
            // 表單驗證
            this.$refs.form.validate((valid) => {
                if (valid) {
                    if (this.form.untList.length <= 0) {
                        this.$message({
                            showClose: true,
                            message: '請至少勾選一個功能權限。',
                            type: 'error',
                        });
                        return;
                    }

                    // 送出
                    this.isAddingStaff = true;
                    this.$api({
                        url: '/StaffManagementPage/UpsertStaff',
                        method: 'post',
                        data: this.form,
                    })
                        .then(() => {
                            this.editDialogVisible = false;
                            this.$message({
                                showClose: true,
                                message: '新增員工成功。',
                                type: 'success',
                            });
                            this.updateStaffList();
                        })
                        .finally(() => {
                            this.isAddingStaff = false;
                        });
                } else {
                    this.scrollViewToError();
                    return false;
                }
            });
        },

        // 滾動到有錯誤的欄位
        scrollViewToError() {
            setTimeout(() => {
                const isError = document.getElementsByClassName('is-error');
                if (isError.length > 0) {
                    isError[0].scrollIntoView({
                        block: 'center',
                        behavior: 'smooth',
                    });
                }
            }, 100);
        },

        // 上一步
        handlePrev() {
            this.$router.push({ name: 'setup-company' });
        },

        // 下一步
        handleNext() {
            this.$router.push({ name: 'setup-bank' });
        },
    },
};
</script>
<style lang="scss">
.setup-authority-table {
    .root-item {
        background-color: #f4f4f4;
        padding: 2px 10px;
        border-radius: 5px;
    }

    .group-items {
        margin: 5px 10px 12px 80px;

        .sub-item {
            display: inline-block;
            padding-right: 25px;
        }
    }
}
</style>
